import styled from "styled-components";

export const Prices = styled.div`
    /* width: 100%; */

    .parameters{
        display: flex;
        /* width: 100%; */
        flex-direction: column;
        border-radius: 10px;
        background-color: #ffffff;
        box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);

        .items{
            width: 100%;
            display: flex;
            flex-direction: row;
            justify-content:start;
            align-items: center;
            justify-content: space-between;
            margin-top: 15px;

            &:first-child {
                margin-top: 20px;

            }

            .inputs{
                display: flex;
                flex-direction: column;
                margin: 0 20px;

                label{
                    color: #403F4C;
                    font-size: 14px;
                    font-weight: bold;
                    padding: 0 0 3px 3px;
                }

                input{
                    width: 150px;
                    height: 32px;
                    border: 1px solid #B2B2B7;
                    border-radius: 26px;
                    padding-left: 10px;
                    background: transparent;
                }

                &:nth-child(2){
                    margin: 0 10px 0 10px;
                    width: 100%;
                    input{
                        width: 100%;
                    }
                }
            }

            span{
                color: #FF5666;
                font-size: 12px;
                margin-top: 7px;
                cursor: pointer;
                font-weight: bold;

                .fa{
                    font-size: 15px;
                    margin-top: 10px;
                }
            }

            &:last-child{
                margin-bottom: 45px;
            }
        }

        button{
            background-color: transparent;
            border: 1px solid #787780;
            color: #403F4C;
            font-weight: bold;
            font-size: 11px;
            border-radius: 26px;
            width: 95px;
            height: 32px;
            margin-top: 32px;
            margin-right: 10px;
            cursor: pointer;
        }

    }

    .button{
        display: flex;
        width: 100%;
        justify-content: flex-end;
        margin-top: 15px;

        button.save{
          padding: 10px 20px;
            height: 38px;
            border-radius: 26px;
            background: #004FFF;
            border: 1px solid #004FFF;
            color: #fff;
            cursor: pointer;
            font-size: 14px;
            font-weight: bold;
            margin: 24px 0 30px 0;
            font-family: 'Work Sans', sans-serif;
        }

        button.back{
            width: 72px;
            height: 28px;
            border-radius: 26px;
            background: transparent;
            border: 1px solid #787780;
            color: #787780;
            cursor: pointer;
            font-size: 11px;
            font-weight: bold;
            margin: 30px 15px 30px 0px;
            font-family: 'Quicksand', sans-serif;

            .fa{
                margin-right: 3px;
            }
        }
    }
`;
